export interface JoinCodeCountry {
  code: string;
  country: MingaCountryEnum;
}

export enum MingaCountryEnum {
  CAN = 'CAN',
  USA = 'USA',
  INTL = 'INTL',
}
